export const BUTTON_RADIUS = '25px'
